// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Player KoT arena title bar */

.lt-kot-bar {
  --lt-kot-bar-h: clamp(52px, 13vh, 64px);
  display: flex;
  align-items: stretch;
  gap: 10px;
  width: 100%;
  min-height: var(--lt-kot-bar-h);
  max-height: calc(var(--lt-kot-bar-h) + 8px);
  padding: 5px 10px;
  flex-shrink: 0;
  box-sizing: border-box;
  border-bottom: 1px solid rgba(251, 191, 36, 0.22);
  background: rgba(251, 191, 36, 0.06);
}

.lt-kot-bar__logo {
  flex-shrink: 0;
  display: flex;
  align-items: center;
  align-self: stretch;
  min-height: calc(var(--lt-kot-bar-h) - 10px);
}

.lt-kot-bar__content {
  flex: 1 1;
  min-width: 0;
  display: grid;
  grid-template-rows: minmax(0, 1fr) minmax(0, 1fr);
  align-content: center;
  gap: 2px;
}

.lt-kot-bar__title-col {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  gap: 0;
  min-width: 0;
  line-height: 1.1;
}

.lt-kot-bar__title-line {
  display: flex;
  flex-direction: row;
  align-items: baseline;
  gap: 0.28em;
  min-width: 0;
  overflow: hidden;
}

.lt-kot-bar__number {
  flex-shrink: 0;
  font-size: clamp(0.72rem, 2.2vh, 0.88rem);
  font-weight: 900;
  color: #fcd34d;
}

.lt-kot-bar__name {
  min-width: 0;
  font-size: clamp(0.76rem, 2.3vh, 0.92rem);
  font-weight: 700;
  color: #f8fafc;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.lt-kot-bar__meta-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  min-width: 0;
  align-self: end;
}

.lt-kot-bar__params {
  display: flex;
  align-items: center;
  gap: 4px;
  flex: 1 1;
  min-width: 0;
  overflow: hidden;
}

.lt-kot-bar__pill {
  display: inline-flex;
  align-items: center;
  padding: 2px 7px;
  border-radius: 999px;
  font-size: clamp(0.58rem, 1.7vh, 0.68rem);
  font-weight: 800;
  letter-spacing: 0.03em;
  text-transform: uppercase;
  white-space: nowrap;
  flex-shrink: 0;
}

.lt-kot-bar__pill--mode {
  background: rgba(251, 191, 36, 0.18);
  color: #fcd34d;
  border: 1px solid rgba(251, 191, 36, 0.35);
}

.lt-kot-bar__pill--round {
  background: rgba(8, 119, 188, 0.2);
  color: #7dd3fc;
  border: 1px solid rgba(8, 119, 188, 0.35);
}

.lt-kot-bar__pill--table {
  background: rgba(255, 255, 255, 0.08);
  color: #e2e8f0;
  border: 1px solid rgba(255, 255, 255, 0.12);
}

.lt-kot-bar__pill--rule {
  background: rgba(255, 255, 255, 0.05);
  color: rgba(248, 250, 252, 0.78);
  border: 1px solid rgba(255, 255, 255, 0.1);
  text-transform: none;
  font-weight: 600;
  overflow: hidden;
  text-overflow: ellipsis;
}

.lt-kot-bar__timer {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  flex-shrink: 0;
  font-size: clamp(0.95rem, 3.2vh, 1.2rem);
  font-weight: 800;
  font-variant-numeric: tabular-nums;
  color: #fbbf24;
  line-height: 1;
}

.lt-kot-bar__timer svg {
  font-size: 1em !important;
  width: 1em;
  height: 1em;
}

.lt-kot-bar__timer--paused {
  color: #fbbf24;
  opacity: 0.85;
}

.lt-kot-bar__timer--idle {
  color: rgba(248, 250, 252, 0.65);
  font-size: clamp(0.85rem, 2.8vh, 1rem);
}
`, "",{"version":3,"sources":["webpack://./src/pages/LiveTraining/LiveTrainingKotTitleBar.css"],"names":[],"mappings":"AAAA,+BAA+B;;AAE/B;EACE,uCAAuC;EACvC,aAAa;EACb,oBAAoB;EACpB,SAAS;EACT,WAAW;EACX,+BAA+B;EAC/B,2CAA2C;EAC3C,iBAAiB;EACjB,cAAc;EACd,sBAAsB;EACtB,iDAAiD;EACjD,oCAAoC;AACtC;;AAEA;EACE,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,4CAA4C;AAC9C;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,aAAa;EACb,iDAAiD;EACjD,qBAAqB;EACrB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,2BAA2B;EAC3B,MAAM;EACN,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,yCAAyC;EACzC,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,yCAAyC;EACzC,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,QAAQ;EACR,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,SAAO;EACP,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,oBAAoB;EACpB,yCAAyC;EACzC,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,cAAc;EACd,0CAA0C;AAC5C;;AAEA;EACE,kCAAkC;EAClC,cAAc;EACd,yCAAyC;AAC3C;;AAEA;EACE,qCAAqC;EACrC,cAAc;EACd,2CAA2C;AAC7C;;AAEA;EACE,qCAAqC;EACrC,gCAAgC;EAChC,0CAA0C;EAC1C,oBAAoB;EACpB,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,wCAAwC;EACxC,gBAAgB;EAChB,kCAAkC;EAClC,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,UAAU;EACV,WAAW;AACb;;AAEA;EACE,cAAc;EACd,aAAa;AACf;;AAEA;EACE,gCAAgC;EAChC,sCAAsC;AACxC","sourcesContent":["/* Player KoT arena title bar */\n\n.lt-kot-bar {\n  --lt-kot-bar-h: clamp(52px, 13vh, 64px);\n  display: flex;\n  align-items: stretch;\n  gap: 10px;\n  width: 100%;\n  min-height: var(--lt-kot-bar-h);\n  max-height: calc(var(--lt-kot-bar-h) + 8px);\n  padding: 5px 10px;\n  flex-shrink: 0;\n  box-sizing: border-box;\n  border-bottom: 1px solid rgba(251, 191, 36, 0.22);\n  background: rgba(251, 191, 36, 0.06);\n}\n\n.lt-kot-bar__logo {\n  flex-shrink: 0;\n  display: flex;\n  align-items: center;\n  align-self: stretch;\n  min-height: calc(var(--lt-kot-bar-h) - 10px);\n}\n\n.lt-kot-bar__content {\n  flex: 1;\n  min-width: 0;\n  display: grid;\n  grid-template-rows: minmax(0, 1fr) minmax(0, 1fr);\n  align-content: center;\n  gap: 2px;\n}\n\n.lt-kot-bar__title-col {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: flex-start;\n  gap: 0;\n  min-width: 0;\n  line-height: 1.1;\n}\n\n.lt-kot-bar__title-line {\n  display: flex;\n  flex-direction: row;\n  align-items: baseline;\n  gap: 0.28em;\n  min-width: 0;\n  overflow: hidden;\n}\n\n.lt-kot-bar__number {\n  flex-shrink: 0;\n  font-size: clamp(0.72rem, 2.2vh, 0.88rem);\n  font-weight: 900;\n  color: #fcd34d;\n}\n\n.lt-kot-bar__name {\n  min-width: 0;\n  font-size: clamp(0.76rem, 2.3vh, 0.92rem);\n  font-weight: 700;\n  color: #f8fafc;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.lt-kot-bar__meta-row {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 8px;\n  min-width: 0;\n  align-self: end;\n}\n\n.lt-kot-bar__params {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  flex: 1;\n  min-width: 0;\n  overflow: hidden;\n}\n\n.lt-kot-bar__pill {\n  display: inline-flex;\n  align-items: center;\n  padding: 2px 7px;\n  border-radius: 999px;\n  font-size: clamp(0.58rem, 1.7vh, 0.68rem);\n  font-weight: 800;\n  letter-spacing: 0.03em;\n  text-transform: uppercase;\n  white-space: nowrap;\n  flex-shrink: 0;\n}\n\n.lt-kot-bar__pill--mode {\n  background: rgba(251, 191, 36, 0.18);\n  color: #fcd34d;\n  border: 1px solid rgba(251, 191, 36, 0.35);\n}\n\n.lt-kot-bar__pill--round {\n  background: rgba(8, 119, 188, 0.2);\n  color: #7dd3fc;\n  border: 1px solid rgba(8, 119, 188, 0.35);\n}\n\n.lt-kot-bar__pill--table {\n  background: rgba(255, 255, 255, 0.08);\n  color: #e2e8f0;\n  border: 1px solid rgba(255, 255, 255, 0.12);\n}\n\n.lt-kot-bar__pill--rule {\n  background: rgba(255, 255, 255, 0.05);\n  color: rgba(248, 250, 252, 0.78);\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  text-transform: none;\n  font-weight: 600;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.lt-kot-bar__timer {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  flex-shrink: 0;\n  font-size: clamp(0.95rem, 3.2vh, 1.2rem);\n  font-weight: 800;\n  font-variant-numeric: tabular-nums;\n  color: #fbbf24;\n  line-height: 1;\n}\n\n.lt-kot-bar__timer svg {\n  font-size: 1em !important;\n  width: 1em;\n  height: 1em;\n}\n\n.lt-kot-bar__timer--paused {\n  color: #fbbf24;\n  opacity: 0.85;\n}\n\n.lt-kot-bar__timer--idle {\n  color: rgba(248, 250, 252, 0.65);\n  font-size: clamp(0.85rem, 2.8vh, 1rem);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
